import AdminGate from './AdminGate';

function AdminRoute({ children, title }) {
  return <AdminGate title={title}>{children}</AdminGate>;
}

export default AdminRoute;
